import React from "react";
import PermissionCell from "./PermissionCell";

const PermissionsCategoryRow = ({
  category,
  permissionTypes,
  onPermissionChange,
  isPermissionDisabled,
  formsContentType,
}) => {
  return (
    <tr className="bg-white border-t-2 border-b-2 border-gray-300">
      <td className="p-2 pl-3 font-semibold">{category.name}</td>
      {permissionTypes.map((permType) => {
        const disabled = isPermissionDisabled
          ? isPermissionDisabled(category.id, permType)
          : false;

        return (
          <PermissionCell
            key={permType}
            isCategory={true}
            categoryId={category.id}
            itemId={null}
            permissionType={permType}
            isEnabled={category.permissions[permType]}
            onPermissionChange={(catId, itemId, permType, value) => {
              onPermissionChange(catId, itemId, permType, value, {
                contentType: formsContentType,
              });
            }}
            disabled={disabled}
          />
        );
      })}
    </tr>
  );
};

export default PermissionsCategoryRow;
